import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody, Button } from 'reactstrap';
import PassageBuilder from '../../../components/QuestionBank/PassageBuilder';
import PassagesList from '../../../components/QuestionBank/PassagesList';

// Error boundary to prevent crashes from propagating
class PassagePageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ManagePassagesPage error boundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Card className="shadow mt-4">
          <CardBody className="text-center py-5">
            <i className="fas fa-exclamation-triangle fa-3x text-warning mb-3"></i>
            <h3>Something went wrong</h3>
            <p className="text-muted">
              An error occurred while loading this section. Please try refreshing the page.
            </p>
            <Button
              color="primary"
              onClick={() => this.setState({ hasError: false, error: null })}
            >
              <i className="fas fa-redo mr-2"></i>
              Try Again
            </Button>
          </CardBody>
        </Card>
      );
    }
    return this.props.children;
  }
}

const ManagePassagesPage = ({ userDetails }) => {
  const userEmail = userDetails?.email || '';
  const history = useHistory();
  const [editingPassage, setEditingPassage] = useState(null);

  return (
    <>
      {/* Header */}
      <div className="header bg-gradient-success pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            <h1 className="text-white mb-0">Manage Passages</h1>
            <p className="text-white mt-0 mb-0">Create and manage reading passages for passage-based questions</p>
          </div>
        </Container>
      </div>

      {/* Page content */}
      <Container className="mt--7" fluid>
        <PassagePageErrorBoundary>
          <Row>
            <Col lg="12">
              <PassageBuilder
                userEmail={userEmail}
                editingPassage={editingPassage}
                onPassageSaved={() => {
                  setEditingPassage(null);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col lg="12">
              <PassagesList
                onEditPassage={(passage) => {
                  setEditingPassage(passage);
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                onCreateQuestionForPassage={(passage) => {
                  history.push(`/admin/question-bank/create-question?passageId=${passage.passageId}`);
                }}
                onEditQuestion={(question) => {
                  history.push(`/admin/question-bank/create-question?edit=${question.questionId}`);
                }}
              />
            </Col>
          </Row>
        </PassagePageErrorBoundary>
      </Container>
    </>
  );
};

const mapStateToProps = (state) => ({
  userDetails: state.loginAuth.userDetails
});

export default connect(mapStateToProps)(ManagePassagesPage);
